import { Alert, Box, Button, Stack, Typography } from "@mui/material";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import LocalPrintshopOutlinedIcon from "@mui/icons-material/LocalPrintshopOutlined";
import ReceiptLongRoundedIcon from "@mui/icons-material/ReceiptLongRounded";
import { useLocation, useNavigate } from "react-router-dom";
import PageTopBar from "../../../components/common/PageTopBar";
import {
  PublicFormButton,
  PublicFormCard,
} from "../../../components/common/form/PublicFormCard";
import { printReceipt } from "../services/feePaymentService";

interface PaymentSuccessState {
  receiptNo: string;
  gradeName: string;
  admissionNo: string;
}

export const PaymentSuccess = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const state = location.state as PaymentSuccessState;

  if (!state?.receiptNo) {
    return (
      <Box sx={{ mt: 2, mr: 2 }}>
        <PageTopBar left="Fee Payment" />
        <Box sx={{ display: "flex", justifyContent: "center", px: 2, py: 4 }}>
          <Alert
            severity="error"
            sx={{ width: "100%", maxWidth: 480, borderRadius: 2 }}
          >
            Invalid payment state. Please contact Admin.
          </Alert>
        </Box>
      </Box>
    );
  }

  const { receiptNo, gradeName, admissionNo } = state;
  const receiptNos = receiptNo.split(",").map((r) => r.trim());
  const isMultiple = receiptNos.length > 1;

  return (
    <Box sx={{ mt: 2, mr: 2 }}>
      {/* Same heading as the Fee Payment step this page completes */}
      <PageTopBar left="Fee Payment" />
      <PublicFormCard
        icon={<CheckCircleRoundedIcon />}
        tone="success"
        title="Payment Successful"
        subtitle={
          isMultiple
            ? `${receiptNos.length} receipts generated.`
            : `Receipt #${receiptNos[0]} generated.`
        }
        maxWidth={480}
      >
        {/* Receipt list */}
        <Stack spacing={1.25}>
          {receiptNos.map((rNo) => (
            <Box
              key={rNo}
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1.5,
                px: 2,
                py: 1.25,
                borderRadius: 2,
                border: "1px solid #e5e7eb",
                bgcolor: "#f8fafc",
              }}
            >
              <Box
                sx={{
                  width: 36,
                  height: 36,
                  borderRadius: 1.5,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  bgcolor: "rgba(25, 118, 210, 0.08)",
                  color: "primary.main",
                  flexShrink: 0,
                }}
              >
                <ReceiptLongRoundedIcon fontSize="small" />
              </Box>
              <Typography
                sx={{
                  flexGrow: 1,
                  fontWeight: 600,
                  color: "#0f172a",
                  fontSize: 15,
                }}
              >
                Receipt #{rNo}
              </Typography>
              <Button
                variant="outlined"
                size="small"
                startIcon={<LocalPrintshopOutlinedIcon />}
                onClick={() =>
                  printReceipt(Number.parseInt(rNo))
                }
                sx={{
                  textTransform: "none",
                  fontWeight: 600,
                  borderRadius: 2,
                  bgcolor: "#fff",
                }}
              >
                Print
              </Button>
            </Box>
          ))}
        </Stack>

        {/* Footer action */}
        <PublicFormButton
          sx={{ mt: 3 }}
          onClick={() => navigate("/app/fees/outstanding")}
        >
          Go to Fee Dues
        </PublicFormButton>
      </PublicFormCard>
    </Box>
  );
};
